import { render, staticRenderFns } from "./left-first.vue?vue&type=template&id=479b1305&scoped=true&"
import script from "./left-first.vue?vue&type=script&lang=js&"
export * from "./left-first.vue?vue&type=script&lang=js&"
import style0 from "./left-first.vue?vue&type=style&index=0&id=479b1305&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479b1305",
  null
  
)

export default component.exports